import './bootstrap';
import "promise-polyfill/src/polyfill";

let menuTrigger = document.querySelector(".menu-trigger"),
    mainNav = document.querySelector("nav"),
    bodyEl = document.querySelector("body"),
    langTrigger = document.querySelector(".nav-item._lang"),
    langItems = document.getElementsByClassName("lang-items"),
    surveyModal = document.getElementById("survey-modal"),
    encModal = document.getElementById("enc-modal"),
    openAccordions = document.getElementById("show-all-accordions"),
    openEncAccordions = document.querySelectorAll(".show-all-enc");

if (menuTrigger && mainNav) {
    menuTrigger.onclick = () => {
        if (!mainNav.classList.contains("is-menu-active")) {
            mainNav.classList.add("is-menu-active");
            bodyEl.style.overflow = "hidden";
            bodyEl.style.position = "relative";
        } else {
            mainNav.classList.remove("is-menu-active");
            bodyEl.style.overflow = "auto";
            bodyEl.style.position = "static";
        }
    };
}

if (langTrigger) {
    langTrigger.onclick = () => {
        if (!langTrigger.classList.contains("is-lang-active")) {
            langTrigger.classList.add("is-lang-active");
        } else {
            langTrigger.classList.remove("is-lang-active");
        }
    };
}

let fixedNav = document.getElementById("start");

if (encModal) {
    // if (getCookie(`enc_shown`) != 1) {
    if (!encModal.classList.contains("active")) {
        // setCookie(`enc_shown`, 1, 30);

        // post that the modal was shown and set session
        axios.post(route("set-enc-seen"));

        encModal.classList.add("active");
        bodyEl.style.overflow = "hidden";
    }
    // }

    let close = encModal.querySelector(".close");
    let closeOnAction = encModal.querySelector(".close-on-action");

    close.onclick = () => {
        if (encModal.classList.contains("active")) {
            encModal.classList.remove("active");
            bodyEl.style.overflow = "auto";
        }
    };

    closeOnAction.onclick = () => {
        if (encModal.classList.contains("active")) {
            encModal.classList.remove("active");
            bodyEl.style.overflow = "auto";
        }
    };
}

window.onscroll = () => {
    if (surveyModal) {
        let uniqueSurvey = surveyModal.dataset.unique;

        if (
            getCurrentScroll() > 200 &&
            getCookie(`survey_shown_${uniqueSurvey}`) != 1
        ) {
            if (!surveyModal.classList.contains("active")) {
                setCookie(`survey_shown_${uniqueSurvey}`, 1, 30);
                surveyModal.classList.add("active");
                bodyEl.style.overflow = "hidden";
            }
        }

        let close = surveyModal.querySelector(".close");

        close.onclick = () => {
            if (surveyModal.classList.contains("active")) {
                surveyModal.classList.remove("active");
                bodyEl.style.overflow = "auto";
            }
        };
    }

    if (fixedNav) {
        let x = window.matchMedia("(min-width: 1400px)"),
            y = window.matchMedia("(min-height: 800px)"),
            q = window.matchMedia("(max-width: 1024px)"),
            subtract = x.matches ? 100 : 60;

        if (y.matches || q.matches) {
            if (
                window.pageYOffset >
                document.querySelector(".subpage-header").clientHeight -
                    subtract
            ) {
                fixedNav.classList.add("sticky-nav");
            } else {
                fixedNav.classList.remove("sticky-nav");
            }
        }
    }

    if (/MSIE \d|Trident.*rv:/.test(navigator.userAgent)) {
        let sidebar = document.getElementById("start");

        if (sidebar) {
            sidebar.style.position = "static !important";
        }
    }
};

function getCurrentScroll() {
    return window.pageYOffset || document.documentElement.scrollTop;
}

function setCookie(name, value, durationDays) {
    var d = new Date();
    d.setTime(d.getTime() + durationDays * 24 * 60 * 60 * 1000);
    var expires = "expires=" + d.toUTCString();
    document.cookie = name + "=" + value + ";" + expires + ";path=/";
}

function getCookie(cookie) {
    var name = cookie + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(";");

    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];

        while (c.charAt(0) == " ") {
            c = c.substring(1);
        }

        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }

    return "";
}

let accQuestion = document.getElementsByClassName("accordion-question");

for (let k = 0; k < accQuestion.length; k++) {
    accQuestion[k].addEventListener("click", function () {
        let panelQuestion = this.nextElementSibling;

        if (panelQuestion.style.maxHeight) {
            hideAllQuestions();
            panelQuestion.style.maxHeight = null;
        } else {
            hideAllQuestions();
            this.classList.add("active-enc");
            panelQuestion.style.maxHeight = panelQuestion.scrollHeight + "px";
        }
    });
}

function hideAllQuestions() {
    for (let k = 0; k < accQuestion.length; k++) {
        accQuestion[k].classList.remove("active-enc");
        accQuestion[k].nextElementSibling.style.maxHeight = null;
    }
}

function showAllQuestions() {
    for (let k = 0; k < accQuestion.length; k++) {
        let panelQuestion = accQuestion[k].nextElementSibling;

        accQuestion[k].classList.add("active-enc");
        panelQuestion.style.maxHeight = panelQuestion.scrollHeight + "px";
    }
}

if (openAccordions) {
    openAccordions.addEventListener("click", function () {
        if (accQuestion[0].classList.contains("active-enc")) {
            openAccordions.querySelector(".indicator").innerHTML = "+";
            hideAllQuestions();
        } else {
            openAccordions.querySelector(".indicator").innerHTML = "-";
            showAllQuestions();
        }
    });
}

let accEnc = document.getElementsByClassName("accordion-enc");

for (let n = 0; n < accEnc.length; n++) {
    accEnc[n].addEventListener("click", function () {
        let panelEnc = this.nextElementSibling;

        if (panelEnc.style.maxHeight) {
            hideAllEnc();
            panelEnc.style.maxHeight = null;
        } else {
            hideAllEnc();
            this.classList.add("active-enc-green");
            panelEnc.style.maxHeight = panelEnc.scrollHeight + "px";
        }
    });
}

function hideAllEnc() {
    for (let n = 0; n < accEnc.length; n++) {
        accEnc[n].classList.remove("active-enc-green");
        accEnc[n].nextElementSibling.style.maxHeight = null;
    }
}

function showAllEnc() {
    for (let n = 0; n < accEnc.length; n++) {
        let panelEnc = accEnc[n].nextElementSibling;

        accEnc[n].classList.add("active-enc-green");
        panelEnc.style.maxHeight = panelEnc.scrollHeight + "px";
    }
}

if (accEnc) {
    openEncAccordions.forEach((el) => {
        el.addEventListener("click", function () {
            if (accEnc[0].classList.contains("active-enc-green")) {
                el.querySelector(".indicator").innerHTML = "+";
                hideAllEnc();
            } else {
                el.querySelector(".indicator").innerHTML = "-";
                showAllEnc();
            }
        });
    });
}

let accArchives = document.getElementsByClassName("accordion-archives"),
    showArchive = document.getElementById("show-archive"),
    hideArchive = document.getElementById("hide-archive");

for (let m = 0; m < accArchives.length; m++) {
    accArchives[m].addEventListener("click", function () {
        this.classList.toggle("active-archives");
        showArchive.classList.toggle("hide");
        hideArchive.classList.toggle("show");
        let panelArchive = this.nextElementSibling;
        if (panelArchive.style.maxHeight) {
            panelArchive.style.maxHeight = null;
        } else {
            panelArchive.style.maxHeight = panelArchive.scrollHeight + "px";
        }
    });
}

let accSubMenu = document.getElementsByClassName("submenu-accordion");

for (let p = 0; p < accSubMenu.length; p++) {
    accSubMenu[p].addEventListener("click", function () {
        this.classList.toggle("active-submenu-accordion");
        let panelSideNav = this.nextElementSibling;
        if (panelSideNav.style.maxHeight) {
            panelSideNav.style.maxHeight = null;
            panelSideNav.style.paddingBottom = "0px";
        } else {
            panelSideNav.style.maxHeight = "calc(100vh - 120px)";
            panelSideNav.style.paddingBottom = "10px";
        }
    });
}

let accPanelNav = document.getElementsByClassName("accordion-nav");

for (let s = 0; s < accPanelNav.length; s++) {
    accPanelNav[s].addEventListener("click", function (e) {
        let panelNav = this.nextElementSibling;
        
        // Check if next sibling is a panel (nested accordion) or panel-nav
        if (panelNav && panelNav.classList.contains("panel")) {
            // Use maxHeight for panel (nested accordion)
            e.preventDefault();
            
            // Function to update all parent panel-nav and panel elements
            let updateParentPanels = () => {
                // Find the main panel-nav (for "O nama")
                let mainPanelNav = null;
                let currentElement = this.parentElement;
                
                while (currentElement) {
                    if (currentElement.classList && currentElement.classList.contains("panel-nav")) {
                        mainPanelNav = currentElement;
                        break;
                    }
                    currentElement = currentElement.parentElement;
                }
                
                // Also find any parent panel elements that might need updating
                let parentPanels = [];
                currentElement = this.parentElement;
                
                while (currentElement) {
                    if (currentElement.classList && currentElement.classList.contains("panel") && currentElement !== panelNav) {
                        parentPanels.push(currentElement);
                    }
                    currentElement = currentElement.parentElement;
                }
                
                // Update main panel-nav
                if (mainPanelNav && mainPanelNav.style.maxHeight && mainPanelNav.style.maxHeight !== "none") {
                    // Use fit-content for automatic height calculation
                    mainPanelNav.style.maxHeight = "fit-content";
                }
                
                // Update parent panels
                parentPanels.forEach(parentPanel => {
                    if (parentPanel.style.maxHeight && parentPanel.style.maxHeight !== "none") {
                        // Use fit-content for automatic height calculation
                        parentPanel.style.maxHeight = "fit-content";
                    }
                });
            };
            
            if (panelNav.style.maxHeight && panelNav.style.maxHeight !== "none") {
                panelNav.style.maxHeight = null;
                panelNav.style.paddingTop = null;
                panelNav.style.paddingBottom = null;
                
                // Update all parent panel-nav elements
                updateParentPanels();
            } else {
                // Set padding first
                panelNav.style.paddingBottom = "1rem";
                
                // Use fit-content for automatic height calculation
                panelNav.style.maxHeight = "fit-content";
                
                // Update all parent panel-nav elements
                updateParentPanels();
            }
        } else if (panelNav && panelNav.classList.contains("panel-nav")) {
            // Use maxHeight for panel-nav
            if (panelNav.style.maxHeight && panelNav.style.maxHeight !== "none") {
                panelNav.style.maxHeight = null;
            } else {
                // First, open active nested panels BEFORE calculating height
                let allNestedPanels = panelNav.querySelectorAll(".panel");
                
                allNestedPanels.forEach(nestedPanel => {
                    let trigger = nestedPanel.previousElementSibling;
                    if (trigger && trigger.classList.contains("accordion-nav") && trigger.classList.contains("active-acc-nav")) {
                        // Open active panels immediately
                        if (!nestedPanel.style.maxHeight || nestedPanel.style.maxHeight === "none") {
                            nestedPanel.style.paddingBottom = "1rem";
                            // Recursively open nested panels within this panel
                            let nestedNestedPanels = nestedPanel.querySelectorAll(".panel");
                            nestedNestedPanels.forEach(nestedNestedPanel => {
                                let nestedTrigger = nestedNestedPanel.previousElementSibling;
                                if (nestedTrigger && nestedTrigger.classList.contains("accordion-nav") && nestedTrigger.classList.contains("active-acc-nav")) {
                                    if (!nestedNestedPanel.style.maxHeight || nestedNestedPanel.style.maxHeight === "none") {
                                        nestedNestedPanel.style.paddingBottom = "1rem";
                                        nestedNestedPanel.style.maxHeight = "fit-content";
                                    }
                                }
                            });
                            nestedPanel.style.maxHeight = "fit-content";
                        }
                    }
                });
                
                // Use fit-content for automatic height calculation
                panelNav.style.maxHeight = "fit-content";
            }
        }
    });
}

// Close menu when clicking anchor links on "Stanje na autocestama" page
// Find all anchor links that point to conditions page with hash
let allLinks = document.querySelectorAll('a[href*="#"]');

allLinks.forEach(link => {
    let href = link.getAttribute('href');
    
    // Check if this is an anchor link to conditions page
    if (href && href.includes('stanje-na-autocestama') && href.includes('#')) {
        link.addEventListener('click', function(e) {
            // Check if we're currently on the conditions page
            let currentUrl = window.location.href.split('#')[0];
            let linkUrl = this.href.split('#')[0];
            
            // If we're on the same page, close the menu
            if (currentUrl === linkUrl || window.location.pathname.includes('stanje-na-autocestama')) {
                // Close all panels
                let allPanels = document.querySelectorAll('.panel, .panel-nav');
                allPanels.forEach(panel => {
                    if (panel.style.maxHeight && panel.style.maxHeight !== 'none') {
                        panel.style.maxHeight = null;
                        panel.style.paddingTop = null;
                        panel.style.paddingBottom = null;
                    }
                });
                
                // Close all accordion triggers
                let allAccordionNavs = document.querySelectorAll('.accordion-nav');
                allAccordionNavs.forEach(accNav => {
                    accNav.classList.remove('active-acc-nav');
                });
                
                // Close mobile menu
                if (mainNav && mainNav.classList.contains('is-menu-active')) {
                    mainNav.classList.remove('is-menu-active');
                    bodyEl.style.overflow = 'auto';
                    bodyEl.style.position = 'static';
                }
            }
        });
    }
});

//Close mobile menu on resize
if (document.getElementById("nav")) {
    window.addEventListener("resize", () => {
        if (screen.width > 1399) {
            document.getElementById("nav").classList.remove("is-menu-active");
        }
    });
}

// Search overlay: the menu bar is full, so the magnifier opens a panel instead
// of carrying a permanent input.
let searchTrigger = document.getElementById("search-trigger"),
    searchOverlay = document.getElementById("search-overlay");

if (searchTrigger && searchOverlay) {
    let searchInput = document.getElementById("search-overlay-input"),
        searchClose = searchOverlay.querySelector(".search-overlay-close");

    let openSearch = () => {
        searchOverlay.hidden = false;
        searchTrigger.setAttribute("aria-expanded", "true");
        // The panel is only visible on the next frame, and focus() before that
        // does not move the caret.
        window.requestAnimationFrame(() => searchInput.focus());
    };

    let closeSearch = () => {
        searchOverlay.hidden = true;
        searchTrigger.setAttribute("aria-expanded", "false");
    };

    searchTrigger.addEventListener("click", () => {
        searchOverlay.hidden ? openSearch() : closeSearch();

        // On mobile the trigger lives inside the burger menu.
        if (mainNav && mainNav.classList.contains("is-menu-active")) {
            mainNav.classList.remove("is-menu-active");
            bodyEl.style.overflow = "auto";
            bodyEl.style.position = "static";
        }
    });

    if (searchClose) {
        searchClose.addEventListener("click", closeSearch);
    }

    searchOverlay.addEventListener("click", event => {
        if (event.target === searchOverlay) {
            closeSearch();
        }
    });

    document.addEventListener("keydown", event => {
        if (event.key === "Escape" && !searchOverlay.hidden) {
            closeSearch();
            searchTrigger.focus();
        }
    });
}

// Search results page: changing a filter chip applies it straight away rather
// than waiting for the user to press the button again.
let searchFilters = document.querySelector(".search-filters");

if (searchFilters) {
    searchFilters.addEventListener("change", event => {
        if (event.target.matches("input[type=radio], input[type=checkbox]")) {
            event.target.form.submit();
        }
    });
}
